import { create } from "zustand";

const useGlobalStore = create((set) => ({
  loadingZs: false,
  messageZs: "",
  setLoadingZs: (loading) => set({ loadingZs: loading }),
  setMessageZs: (message) => set({ messageZs: message }),
  setMessageEmptyZs: () => set({ messageZs: "" }),
}));

export default useGlobalStore;
